import { useAccess } from "./useAccess";

export function useCanWrite(nodeId: string): boolean {
  const { can, catalog } = useAccess();

  if (catalog.nodes[nodeId] === undefined) return true;

  return can(nodeId, "write");
}

export default useCanWrite;
